@if (options.control && options.items) {
  <div class="select__input relative">
    <!-- <select2
      [data]="options.items"
      [templates]="{
        qrCodeTemplateColorScheme,
        logo,
        label,
        group,
        phoneCountry,
      }"
      [formControl]="options.control"
      [grid]="options.grid || ''"
      [resettable]="true"
      [customSearchEnabled]="true"
      (search)="search($event)"
    >
      <ng-template #group let-label="label" let-options="options">
        <span [translate]="label"> </span>
      </ng-template>

      <ng-template #label let-label="label">
        <span [translate]="label"> </span>
      </ng-template>

      <ng-template #qrCodeTemplateColorScheme let-data="data">
        <div class="flex flex-row space-x-1">
          <div
            class="rounded-full h-6 w-6"
            *ngFor="let color of data.colors"
            [style.backgroundColor]="color"
          ></div>
          <div>
            {{ data.name  | translate
             }}
          </div>
        </div>
      </ng-template>

      <ng-template #logo let-value="value">
        <div class="text-center h-6 w-6">
          <img [src]="value" loading="lazy" />
        </div>
      </ng-template>

      <ng-template #phoneCountry let-data="data" let-label="label">
        <span>
          <img
            class="rounded-l-lg"
            [src]="'assets/media/images/flags' + data.flag"
            loading="lazy"
            width="25"
          />
          {{ data.name }}
        </span>
      </ng-template>
    </select2> -->

    <ng-select
      [ngClass]="{ 'inline-option': options.valueIsImg }"
      [appendTo]="options.valueIsImg ? '' : 'body'"
      [items]="options.items"
      bindLabel="label"
      bindValue="value"
      [groupBy]="options.groupBy || ''"
      [formControl]="options.control"
      (focus)="isFocused = true"
      (blur)="isFocused = false"
      [searchable]="options.searchable"
      [notFoundText]="('No Items Found' | translate | async) || ''"
    >
      @if (!options.searchable) {
        <ng-template ng-header-tmp let-item$="item$"> </ng-template>
      }

      <ng-template ng-label-tmp let-item="item">
        @if (options.valueIsImg) {
          <img
            class="rounded-full inline-block"
            [src]="item.value"
            loading="lazy"
            width="20"
          />
        } @else if (item.icon) {
          <img
            class="rounded-full inline-block"
            [src]="'assets/media/images/flags' + item.icon"
            loading="lazy"
            width="20"
          />
          <span class="m-2 text-wrap" [translate]="item.label"></span>
        } @else if (options.groupBy && item[options.groupBy] && item.label) {
          <span class="m-2"
            >{{ item[options.groupBy] | translate | async }}:
            {{ item.label | translate | async }}</span
          >
        } @else if (options.groupBy && item[options.groupBy]) {
          <span class="m-2" [translate]="item[options.groupBy]"></span>
        } @else if (item.data?.colors?.length) {
          <div class="flex flex-row space-x-1">
            <div
              class="rounded-full h-6 w-6"
              *ngFor="let color of item.data.colors"
              [style.backgroundColor]="color"
            ></div>
            <div [translate]="item.label"></div>
          </div>
        } @else {
          <span class="m-2" [translate]="item.label"></span>
        }
      </ng-template>

      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        @if (options.valueIsImg) {
          <img
            class="rounded-full inline-block"
            [src]="item.value"
            loading="lazy"
            width="20"
          />
        } @else if (item.icon) {
          <img
            class="rounded-full inline-block"
            [src]="'assets/media/images/flags' + item.icon"
            loading="lazy"
            width="20"
          />
          <span class="m-2 text-wrap" [translate]="item.label"></span>
        } @else if (item.data?.colors?.length) {
          <div class="flex flex-row space-x-1">
            <div
              class="rounded-full h-6 w-6"
              *ngFor="let color of item.data.colors"
              [style.backgroundColor]="color"
            ></div>
            <div [translate]="item.label"></div>
          </div>
        } @else {
          <span class="m-2 text-wrap" [translate]="item.label"></span>
        }
      </ng-template>

      <!-- Custom group header template -->
      <ng-template ng-optgroup-tmp let-item="item">
        <strong>
          {{ item.groupValue | translate | async }}
        </strong>
      </ng-template>
    </ng-select>
    <label
      [ngClass]="{
        active: options.control.value || isFocused,
        required: isRequired,
      }"
      class="select__label reverse__select-label"
      [translate]="options.label"
    >
    </label>
  </div>

  @if (options.isShowErrors) {
    <span
      class="text-red-500 block"
      *ngIf="options.control?.errors?.['required']"
      translate="This field is required"
    ></span>
  }
}
